/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPointFromJSON, StreemApiPointToJSON, } from './';
export function MeasurePresentationFromJSON(json) {
    return MeasurePresentationFromJSONTyped(json, false);
}
export function MeasurePresentationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'vertex2Position': !exists(json, 'vertex2_position') ? undefined : StreemApiPointFromJSON(json['vertex2_position']),
        'units': !exists(json, 'units') ? undefined : json['units'],
    };
}
export function MeasurePresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'vertex2_position': StreemApiPointToJSON(value.vertex2Position),
        'units': value.units,
    };
}
/**
* @export
* @enum {string}
*/
export var MeasurePresentationUnits;
(function (MeasurePresentationUnits) {
    MeasurePresentationUnits["CENTIMETERS"] = "UNITS_CENTIMETERS";
    MeasurePresentationUnits["FEET"] = "UNITS_FEET";
    MeasurePresentationUnits["INCHES"] = "UNITS_INCHES";
    MeasurePresentationUnits["INVALID"] = "UNITS_INVALID";
    MeasurePresentationUnits["MILLIMETERS"] = "UNITS_MILLIMETERS";
})(MeasurePresentationUnits || (MeasurePresentationUnits = {}));
//# sourceMappingURL=MeasurePresentation.js.map